import { useNavigate } from 'react-router';
import { useContextSelector as useCS } from 'use-context-selector';
import { Button, Header } from 'view/components';
import { RolesEnum } from 'infrastructure/enums/RolesEnum';
import { GlobalConfigContext } from 'domain/globalConfig/GlobalConfigContext';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';
import * as S from './styled';

const Page404 = () => {
  const navigate = useNavigate();
  const { role } = useCS(GlobalConfigContext, globalConfigSelectors.userData);
  return (
    <S.Wrapper>
      <Header />
      <S.MainContentWrapper>
        <S.Box404>
          <h1>404</h1>
          <h4>Page not found</h4>
          <p>The page you’re looking for doesn’t exist</p>
          <Button
            variant="contained"
            text="Back to Home"
            onClick={() => {
              if (role?.name === RolesEnum.JOB_SEEKER) {
                navigate('/profile/job-list');
              }
              if (role?.name === RolesEnum.RECRUITER) {
                navigate('/candidates/candidates-list');
              }
            }}
          />
        </S.Box404>
      </S.MainContentWrapper>
    </S.Wrapper>
  );
};

export default Page404;
